// Branded fallback shown when a runtime error breaks a page.
// Rendered by the ErrorBoundary, which may live outside the router —
// so this page uses plain anchors, not react-router Links.
export default function ErrorPage({ onRetry }) {
    return (
        <section className="relative flex min-h-[70vh] flex-col items-center justify-center overflow-hidden bg-canvas px-6 py-24 text-center text-body">
            <span
                aria-hidden="true"
                className="pointer-events-none absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 select-none font-serif text-[14rem] font-medium leading-none text-ink/[0.04] sm:text-[20rem]"
            >
                Oh
            </span>

            <div className="relative">
                <p className="section-kicker">Something went wrong</p>

                <h1 className="font-serif text-balance text-4xl font-medium leading-[1.1] tracking-[-0.02em] text-ink sm:text-5xl">
                    We hit an unexpected error<span className="text-brand">.</span>
                </h1>

                <p className="mx-auto mt-5 max-w-md text-pretty leading-7 text-muted">
                    It's not you — something broke on our side. Reloading usually
                    fixes it. If it keeps happening, write to{" "}
                    <a
                        href="mailto:care@accruewise.in"
                        className="text-brand-pale-ink underline-offset-4 hover:underline"
                    >
                        care@accruewise.in
                    </a>
                    .
                </p>

                <div className="mt-9 flex items-center justify-center gap-6">
                    <button type="button" onClick={onRetry} className="ed-cta">
                        Reload the page
                    </button>
                    <a href="/" className="ed-link">
                        Back to home
                    </a>
                </div>
            </div>
        </section>
    );
}
